@import '../../../../scss/01_settings/variables.scss';

.share {
  position: relative;

  lg-icon {
    font-size: 2rem;
  }

  .nav-link {
    color: $primary;
    &:hover {
      color: $blue-01;
    }
  }

  &-icons {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
}
